/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import "../../App.css";
import DataTable from "react-data-table-component";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Button, Card, TextField } from "@mui/material";
import { withRouter } from "react-router-dom";
import { InfinitySpin } from "react-loader-spinner";

class Feedback extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      restaurent: [],
      DataisLoaded: false,
      rest: "",
      start_date: "",
      end_date: "",
      type: "",
      restro_id: "",
      per_page: 10,
      total:0,
      feedbacktotal:0,

      page:1,
      queryStartDate: "",
      queryEndDate: "",
      queryFilterBy: "",
      queryRestroId: "",
      hitFilterBtn:0,
      isFilterValid: true,
    };
    
    this.fetchData = this.fetchData.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePerRowsChange = this.handlePerRowsChange.bind(this);
    this.fetchQueryParam = this.fetchQueryParam.bind(this);
    this.QueryFeedbackFilter = this.QueryFeedbackFilter.bind(this);
  }

  componentDidMount() {
   
    this.fetchQueryParam();

    this.fetchRestData();
  }

  componentDidUpdate(prevProps) {
    // Check if the query parameters have changed
    if (this.props.location.search !== prevProps.location.search) {
      this.fetchQueryParam();
    }
  }


  fetchQueryParam() {
    const query = new URLSearchParams(this.props.location.search);
    const start_date = query.get("start_date");
    const end_date = query.get("end_date");
    const restro_id = query.get("restro_id");
    const type = query.get("type");

    if (start_date && end_date && type) {
      this.setState({ start_date, end_date, type, rest: restro_id, hitFilterBtn: 1 }, () => {
        this.QueryFeedbackFilter(start_date, end_date, type, restro_id);
      });
    } else if (restro_id) {
      this.setState({ type, rest: restro_id, hitFilterBtn: 1 }, () => {
        this.QueryFeedbackFilter(start_date, end_date, type, restro_id);
      });
    } else if (start_date && end_date && type && restro_id) {
      this.setState({ start_date, end_date, type, rest: restro_id, hitFilterBtn: 1 }, () => {
        this.QueryFeedbackFilter(start_date, end_date, type, restro_id);
      });
    } else {
      if(this.state.hitFilterBtn===0){
        this.fetchData(this.state.page, this.state.per_page);
      }
    }
  }

  QueryFeedbackFilter(startDate, endDate, filterBy, RestroId, page = this.state.page, per_page = this.state.per_page) {
    if (!startDate && !endDate && !filterBy && !RestroId) {
      alert("Please Select Any Filter");
      return;
    }

    if (startDate && !endDate) {
      alert("Please select end date");
      return;
    }

    if (endDate && !startDate) {
      alert("Please select start date");
      return;
    }

    var end_date = endDate;
    var start_date = startDate;
    var rest = RestroId ? RestroId : "";

    var type = filterBy;
    var booking_type = this.booking_type;

    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;

    axios
      .post(endpoints.birthdayFilter, {
        start_date,
        end_date,
        rest,
        type,
        user_id,
        restro_id,
        booking_type,
        page,
        per_page
      })
      .then((response) => {
        this.setState({
          items: response.data.data,
          feedbacktotal: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
      });
  }

  

  fetchData(page, per_page) {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;

    axios
      .post(endpoints.getCustomerFeedback, {
        page,
        per_page,
        user_id,
        restro_id,
      })
      .then((response) => {
        this.setState({
          items: response.data.data,
          feedbacktotal: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        this.setState({ DataisLoaded: true });
      });
  }

  fetchRestData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);

    axios.post(endpoints.getRestaurentsDropDown, {}).then((response) => {
      this.setState({
        restaurent: response.data.data,
        total: response.data.total,
        totalPages: response.data.total_pages,
        DataisLoaded: true,
      });
      // console.log(response.data);
    });
  }


  handlePageChange(page) {
    if (this.state.hitFilterBtn === 0) {
      this.fetchData(page, this.state.per_page);
    } else if (this.state.isFilterValid) {
      this.QueryFeedbackFilter(
        this.state.start_date,
        this.state.end_date,
        this.state.type,
        this.state.rest,
        page,
        this.state.per_page
      );
    }
  }

  handlePerRowsChange(newPerPage, page) {
    this.setState({ per_page: newPerPage }, () => {
      if (this.state.hitFilterBtn === 0) {
        this.fetchData(page, newPerPage);
      } else if (this.state.isFilterValid) {
        this.QueryFeedbackFilter(
          this.state.start_date,
          this.state.end_date,
          this.state.type,
          this.state.rest,
          page,
          newPerPage
        );
      }
    });
  }

  
  render() {
    const removeStatusHandler = async (id, e) => {
      // console.log('status-295',e.target.value)
      const status = e.target.value;
      var word = "";
      if (status === "1") {
        word = "show";
      }
      if (status === "0") {
        word = "hide";
      }
      const confirmBox = window.confirm(
        "Do you want to " + word + " this feedback?"
      );
      if (confirmBox === true) {
        await axios
          .post(endpoints.update_feedback_status, { id, status })
          .then((response) => {});
        window.location.reload();
      }
    };

    const { DataisLoaded, items, total } = this.state;
    const a = this.state.items;
    const b = this.state.total;
    const links = this.state.restaurent;
    const user = localStorage.getItem("user");
    const user_data = JSON.parse(user);
    this.restro_id = user_data.restro_id;
    const dates = new Date();
    const month = JSON.stringify(dates.getMonth() + 1);
    const date = JSON.stringify(dates.getDate());
    const year = JSON.stringify(dates.getFullYear());
    const recent_date = month + "-" + date;

    const ExpandedComponent =
      (suppData) =>
      ({ data }) => {
        return (
          <>
            <div className="row px-5 mt-3">
              <div className="col-md-8">
                <mat-card>
                  <table>
                    <tr>
                      <th >Name</th>
                      <td>{data.name}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>

                

                    <tr>
                      <th>Mobile</th>
                      <td>{data.mobile}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>

                    <tr>
                      <th>Type</th>
                      <td>{data.type}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>

                    <tr>
                      <th>Profession</th>
                      <td>{data.profession}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>

                    {/* <tr>
                      <th>Anniversary</th>
                      <td>{data.anniversary}</td>
                    </tr> */}
                    <tr>
                      <th>DOB</th>
                      <td>{data.dob}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>

                   
                    {/* <tr>
                      <th>Server Name</th>
                      <td>{data.servant_name}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr> */}
                    <tr>
                      <th>Lead Source </th>
                      <td>{data.lead_source}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>
                    <tr>
                      <th>Source</th>
                      <td className="text-nowrap">{data.source}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>

                    <tr>
                      <th>Valuable Feedback </th>
                      <td>{data.valuable_feedback}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>
                    <tr >
                      <th style={{paddingTop:"10px"}}>Dining Experience Better</th>
                      <td className="pl-3" style={{paddingTop:"10px"}}>{data.dining_exp_better}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>
                  </table>
                </mat-card>
              </div>

              <div className="col-md-4">
                <mat-card>
                  <table>
                    <tr>
                      <th className="w-100">Service</th>
                      <td>{data.service}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>
                    <tr>
                      <th>Ambiance</th>
                      <td>{data.ambiance}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>

                    <tr>
                      <th>Music</th>
                      <td>{data.music}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>

                    <tr>
                      <th>Quality of Foodienc</th>
                      <td>{data.qty_of_foodienc}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>

                    <tr>
                      <th>Value for Money</th>
                      <td>{data.val_for_money}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>

                    <tr>
                      <th>Did Manager Visit the Table</th>
                      <td>{data.did_manage_visit}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>

                    <tr>
                      <th>Best about Restaurant</th>
                      <td>{data.what_did_best_like}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>

                   

                 

                    <tr>
                      <th>Address</th>
                      <td>{data.address}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>

                   
                   
                    <tr>
                      <th>Create on </th>
                      <td>{data.create_on}</td>
                    </tr>
                    <tr><td colSpan="2"><hr /></td></tr>

                  </table>
                </mat-card>
              </div>
            </div>
            {suppData}{" "}
          </>
        );
      };
    const columns = [
      {
        selector: (row) => row.name,
        cellExport: (row) => row.name,
        sortable: true,
      },
      // {
      //   selector: (row) => row.email,
      //   cellExport: (row) => row.email,
      //   sortable: true,
      // },
      {
        selector: (row) => row.mobile,
        cellExport: (row) => row.mobile,
        sortable: true,
      },
      {
        cellExport: (row) => row.dob,
        selector: (row) => row.dob,
        omit: true,
        sortable: true,
      },
      {
        cellExport: (row) => row.anniversary,
        selector: (row) => row.anniversary,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.type,
        cellExport: (row) => row.type,
        sortable: true,
      },
      {
        selector: (row) => row.ambiance,
        cellExport: (row) => row.ambiance,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.music,
        cellExport: (row) => row.music,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.service,
        cellExport: (row) => row.service,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.qty_of_foodienc,
        cellExport: (row) => row.qty_of_foodienc,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.val_for_money,
        cellExport: (row) => row.val_for_money,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.did_manage_visit,
        cellExport: (row) => row.did_manage_visit,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.what_did_best_like,
        cellExport: (row) => row.what_did_best_like,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.dining_exp_better,
        cellExport: (row) => row.dining_exp_better,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.valuable_feedback,
        cellExport: (row) => row.valuable_feedback,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.address,
        cellExport: (row) => row.address,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.create_on,
        cellExport: (row) => row.create_on,
        sortable: true,
      },
      
      {
        selector: (row) => row.source,
        cellExport: (row) => row.source,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.lead_source,
        cellExport: (row) => row.lead_source,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) =>
          row.status === "Status" ? (
            "Status"
          ) : (
            <div>
              <select
                name="status"
                required
                className="form-control"
                onChange={(e) => removeStatusHandler(row.id, e)}
                value={this.status}
              >
                <option value={row.status}>
                  {" "}
                  {row.status === 1 ? "Show" : "Hide"}
                </option>
                <option
                  value="1"
                  style={{ ...(row.status === 1 ? { display: "none" } : {}) }}
                >
                  Show
                </option>
                <option
                  value="0"
                  style={{ ...(row.status === 0 ? { display: "none" } : {}) }}
                >
                  Hide
                </option>
              </select>
            </div>
          ),
        cellExport: (row) => row.status,
        sortable: true,
      },
    ];

    const onSubmit = async (e) => {
      this.filterfetch(e);
      // console.log(e)
    };


    const bFilter = () => {
      const { start_date, end_date, type, rest } = this.state;
    
      // Check if at least one filter is selected
      if (!start_date && !end_date && !type && !rest) {
        alert("Please Select Any Filter");
        this.setState({ isFilterValid: false });
        return;
      }
    
      this.setState({ isFilterValid: true, hitFilterBtn: 1 });
    
      // Fetch the data with the selected filters
      this.QueryFeedbackFilter(
        start_date,
        end_date,
        type,
        rest
      );
    
      this.props.history.replace({ search: "" });
    };

    const onStartChange = (e) => {
     this.setState({ start_date: e.target.value });
    };
    const onEndChange = (e) => {
      this.setState({ end_date: e.target.value });
    };
    const onTypeChange = (e) => {
      this.setState({ type: e.target.value });
    };
    const onRestChange = (e) => {
      this.setState({ rest: e.target.value });
    };
    const c = [
      {
        address: "Address ",
        addrress: null,
        ambiance: "Ambiance",
        anniversary: "Anniversary",
        create_on: "Created On",
        did_manage_visit: "Manager Visit",
        dining_exp_better: "Dinning Exp.",
        dob: "DOB",
        email: "Email",
        id: 0,
        mobile: "Number",
        music: "Music",
        name: "Name",
        profession: "Profession",
        qty_of_foodienc: "Qty. Of Food",
        restro_id: 5,
        service: "Service",
        type: "Restaurant",
        val_for_money: "Val. For Money",
        valuable_feedback: "Feedback",
        what_did_best_like: "Best Like",
        servant_name: "Servant Name",
        status: "Status",
        source: "Source",
        lead_source: "Lead_Source",

      },
    ];
    // const data = heading.concat(c);
    const data = c.concat(a);

    const tableData = {
      columns,
      data,
    };

    if (!DataisLoaded)
      return (
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
            color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      );

    return (
      <>
        <h2>Feedback Leads</h2>
        <Card className="px-3 py-3">
          <form
            className="ui form"
            onSubmit={(e) => onSubmit(e)}
            encType="multipart/form-data"
          >
            <div className="row">
              <div className="col-md-3">
                <label>Start Date</label>
                <br />
                <TextField
                  fullWidth
                  id="start_date"
                  label="Start Date"
                  type="date"
                  name="start_date"
                  place="Start Date"
                  value={this.state.start_date}
                  onChange={(e) => onStartChange(e)}
                    requiredInput="required"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="col-md-3">
                <label>End Date</label>
                <br />
                <TextField
                  fullWidth
                  id="end_date"
                  label="End Date"
                  type="date"
                  name="end_date"
                  place="End Date"
                  value={this.state.end_date}
                  onChange={(e) => onEndChange(e)}
                    requiredInput="required"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="col-md-3">
                <label>Status</label>
                <select
                  name="type"
                  required
                  className="form-control"
                  value={this.state.type}
                  onChange={(e) => onTypeChange(e)}
                >
                  <option value="">Select Status</option>
                  <option value="1">By Birth Date</option>
                  <option value="2">By Anniversary Date</option>
                  <option value="3">By Created Date</option>
                </select>
              </div>

              {this.restro_id === 0 ? (
                <div className="col-md-3">
                  <label>Restaurant</label>
                  <select
                    name="rest"
                    required
                    className="form-control"
                    value={this.state.rest}
                    onChange={(e) => onRestChange(e)}
                  >
                    <option value="">Select Restaurant</option>
                    {links.map((e, key) => (
                      <option key={key} value={e.id}>
                        {e.name}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                ""
              )}

              <div className="col col-3">
                <div className="mt-5 text-center">
                  <Button
                    className="w-50"
                    onClick={() => bFilter()}
                    style={{ color: "white" }}
                    variant="contained"
                    size="medium"
                  >
                    Filter
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </Card>
    

<div className="row mt-2">
          <DataTableExtensions {...tableData} filter={false}>
            <DataTable
              defaultSortField="id"
              pagination
          
              paginationServer
              highlightOnHover
              paginationTotalRows={this.state.feedbacktotal}
              onChangePage={this.handlePageChange}
              onChangeRowsPerPage={this.handlePerRowsChange}
              progressPending={!this.state.DataisLoaded}
              expandableRows
              expandableRowsComponent={ExpandedComponent()}
            />
          </DataTableExtensions>
        </div>
      </>
    );
  }
}
export default withRouter(Feedback);
